var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupcake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27457 12.7728C7.94909 12.7416 7.6262 12.6681 7.31433 12.5518L6.41936 12.218C5.64832 11.9304 4.85973 12.5974 5.02122 13.4004L6.41297 20.3212C6.60927 21.2974 7.47105 22 8.47197 22H9.24586L8.27457 12.7728Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 22C10.75 21.9741 10.7487 21.9479 10.7459 21.9215L9.76642 12.6168C9.9545 12.5579 10.1389 12.4839 10.3176 12.395C11.3767 11.8683 12.6233 11.8683 13.6824 12.395C13.8611 12.4839 14.0455 12.5579 14.2336 12.6168L13.2541 21.9215C13.2513 21.9479 13.25 21.9741 13.2499 22H10.7501Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7541 22L15.7254 12.7728C16.0509 12.7416 16.3738 12.6681 16.6857 12.5518L17.5806 12.218C18.3517 11.9304 19.1403 12.5974 18.9788 13.4004L17.587 20.3212C17.3907 21.2974 16.529 22 15.528 22H14.7541Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4404 12.6282C20.1167 11.1985 18.5618 10.2511 17.0565 10.8125L16.1615 11.1463C15.5707 11.3667 14.9141 11.3323 14.3503 11.0519C12.8705 10.316 11.1295 10.316 9.64974 11.0519C9.08589 11.3323 8.42929 11.3667 7.8385 11.1463L6.94354 10.8125C5.43822 10.2511 3.88329 11.1985 3.55959 12.6282C2.59903 11.717 2 10.4285 2 9C2 6.23858 4.23858 4 7 4C7.31972 4 7.63244 4.03001 7.93548 4.08736C8.84287 2.82336 10.3253 2 12 2C13.6747 2 15.1571 2.82336 16.0645 4.08737C16.3676 4.03001 16.6803 4 17 4C19.7614 4 22 6.23858 22 9C22 10.4285 21.401 11.717 20.4404 12.6282Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupcake);
export default __webpack_public_path__ + "static/media/cupcake.d683350dc577bbf720c6813aedd7b9c5.svg";
export { ForwardRef as ReactComponent };